import * as React from 'react'
function SvgAdd(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fill="currentColor"
				d="M23.2 16.8V4h-6.4v12.8H4v6.4h12.8V36h6.4V23.2H36v-6.4z"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgAdd
